import React from 'react';
import styles from './DateSelector.module.scss';

import DatePicker from 'react-date-picker';
import moment from 'moment';
import { FaCalendarAlt } from 'react-icons/fa';
import { $t, $getLanguage } from '../../../helpers/translator';

class DateSelector extends React.Component {
    constructor(props) {
        super(props);
        this.dateRef = React.createRef();

        this.state = {
            date: this.props.selected ? this.props.selected : null,   //always a Moment instance
            lang: $getLanguage()
        };
    }

    setDate(date) {
        this.setState({ date: moment(date) }, () => {
            this.props.onDateChange(this.state.date);
        });
    }

    clickOnElement(ref) {
        this[ ref ].current.openCalendar();
    }

    render() {
        let maxDate = this.props.maxDate ? this.props.maxDate : moment();
        let minDate = this.props.minDate ? this.props.minDate : moment().subtract(120, 'years');

        return (
            <div>
                <div className={ `${styles[ 'actual-calendar' ]}` }>
                    <DatePicker
                        clearIcon={ null }
                        className={ `${styles[ 'calendar-added-cls' ]}` }
                        value={ this.state.date ? this.state.date.toDate() : null }
                        maxDate={ maxDate.toDate() }
                        minDate={ minDate.toDate() }
                        ref={ this.dateRef }
                        onChange={ (date) => {
                            this.setDate(date)
                        } }
                        locale={ this.state.lang }
                    />
                </div>

                <div className={ `${styles[ 'container' ]}` }>
                    <div className={ `${styles[ 'date-container' ]} ${styles[ (this.state.periodError ? ' error-border ' : '') ]}` }
                        onClick={ () => this.clickOnElement('dateRef') }>
                        <div>
                            { this.state.date ? this.state.date.lang(this.state.lang).format('LL') : $t('global.dateTime.selectDate') }
                        </div>

                        <FaCalendarAlt className={ `${styles[ 'icon-container' ]}` } />
                    </div>
                </div>
            </div>
        );
    }
}

export default DateSelector;
